import React from "react";
import { useState, useEffect } from "react";
import InsumosModal from "./InsumosModal";
import {
  deletePrendaInsumo,
  getAllPrendaInsumo,
} from "../functions";
import { IconButton, Box, Typography, Chip, CircularProgress, Tooltip } from "@mui/material";
import { Delete, Edit } from "@mui/icons-material";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import Inventory2Icon from "@mui/icons-material/Inventory2";

const InsumosPrenda = ({ mode, prendaId, setPrendaInsumo, prendaInsumo }) => {
  const [tallas, setTallas] = useState(null);
  const [open, setOpen] = useState(false);
  const [dataPI, setDataPI] = useState([]);
  const [refresh, setRefresh] = useState(true);
  const [loading, setLoading] = useState(false);
  const [editData, setEditData] = useState(null);
  const [editMode, setEditMode] = useState("create");

  const openModal = () => { setEditMode("create"); setOpen(true); };
  const handleClose = () => setOpen(false);

  useEffect(() => {
    if (mode === "PUT") {
      setLoading(true);
      const fetchData = async () => {
        const all = await getAllPrendaInsumo();
        setDataPI(all.filter((item) => item.prendaId === prendaId));
        setLoading(false);
      };
      fetchData();
    }
  }, [open, refresh, mode, prendaId]);

  const deleteFnc = async (data, index) => {
    if (mode === "POST") {
      prendaInsumo.splice(index, 1);
      setPrendaInsumo([...prendaInsumo]);
      setDataPI([...prendaInsumo]);
      return;
    }
    await deletePrendaInsumo(data.id);
    setRefresh(!refresh);
  };

  const handleEdit = (item) => {
    setTallas(null);
    setEditMode("edit");
    setEditData(item);
    setOpen(true);
  };

  return (
    <>
      <InsumosModal
        tallas={tallas}
        setTallas={setTallas}
        editMode={editMode}
        editData={editData}
        open={open}
        handleClose={handleClose}
        mode={mode}
        setPrendaInsumo={setPrendaInsumo}
        setDataPI={setDataPI}
      />

      {/* Botón agregar */}
      <Box sx={{ mb: 2 }}>
        <button
          onClick={openModal}
          style={{
            display: "flex", alignItems: "center", gap: 6,
            background: "linear-gradient(135deg, #f43f5e 0%, #ec4899 100%)",
            border: "none", borderRadius: 8, padding: "8px 16px",
            color: "#fff", cursor: "pointer",
            fontFamily: "'Poppins', sans-serif", fontWeight: 600, fontSize: "0.82rem",
            boxShadow: "0 3px 10px rgba(244,63,94,0.35)",
          }}
        >
          <AddCircleIcon style={{ fontSize: 18 }} />
          Agregar insumo
        </button>
      </Box>

      {/* Estado vacío / loading */}
      {loading && (
        <Box sx={{ display: "flex", alignItems: "center", gap: 2, py: 4 }}>
          <CircularProgress size={20} sx={{ color: "#f43f5e" }} />
          <Typography sx={{ fontFamily: "'Poppins', sans-serif", fontSize: "0.85rem", color: "#9ca3af" }}>
            Cargando insumos...
          </Typography>
        </Box>
      )}

      {!loading && dataPI.length === 0 && (
        <Box sx={{
          display: "flex", flexDirection: "column", alignItems: "center",
          py: 5, gap: 1,
          background: "#fff0f6", borderRadius: 2,
          border: "1px dashed #f9a8d4",
          ".dark &": { background: "rgba(244,63,94,0.05)", border: "1px dashed rgba(244,63,94,0.3)" },
        }}>
          <Inventory2Icon sx={{ color: "#f9a8d4", fontSize: 36 }} />
          <Typography sx={{ fontFamily: "'Poppins', sans-serif", fontSize: "0.85rem", color: "#9ca3af" }}>
            No hay insumos agregados
          </Typography>
        </Box>
      )}

      {/* Lista de insumos */}
      {!loading && dataPI.length > 0 && (
        <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5 }}>
          {dataPI.map((data, index) => (
            <Box
              key={index}
              sx={{
                display: "flex", alignItems: "center", justifyContent: "space-between",
                p: 1.5, borderRadius: 2,
                border: "1px solid #fce7f3",
                background: "#fff",
                transition: "box-shadow 0.2s",
                "&:hover": { boxShadow: "0 2px 12px rgba(244,63,94,0.15)" },
                ".dark &": {
                  background: "#1e293b",
                  border: "1px solid rgba(244,63,94,0.2)",
                  "&:hover": { boxShadow: "0 2px 12px rgba(244,63,94,0.2)" },
                },
              }}
            >
              {/* Info */}
              <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
                <Box sx={{
                  width: 32, height: 32, borderRadius: "50%",
                  background: "linear-gradient(135deg, #f43f5e 0%, #ec4899 100%)",
                  display: "flex", alignItems: "center", justifyContent: "center",
                  flexShrink: 0,
                }}>
                  <Typography sx={{ fontFamily: "'Poppins', sans-serif", fontWeight: 700, color: "#fff", fontSize: "0.72rem" }}>
                    {index + 1}
                  </Typography>
                </Box>
                <Box>
                  <Typography sx={{ fontFamily: "'Poppins', sans-serif", fontWeight: 700, fontSize: "0.85rem", color: "#374151", ".dark &": { color: "#f3f4f6" } }}>
                    {data.insumo?.nombre}
                  </Typography>
                  <Box sx={{ display: "flex", gap: 0.5, mt: 0.3, flexWrap: "wrap" }}>
                    {data.insumo?.codigo && (
                      <Chip label={data.insumo.codigo} size="small"
                        sx={{ fontFamily: "'Poppins', sans-serif", fontSize: "0.65rem", background: "#fce7f3", color: "#be185d", height: 18 }} />
                    )}
                    <Chip label={`${data.cantidad} ${data.unidad || ""}`} size="small"
                      sx={{ fontFamily: "'Poppins', sans-serif", fontSize: "0.65rem", background: "#f0fdf4", color: "#16a34a", height: 18 }} />
                    {data.details && (
                      <Chip label="Por talla" size="small"
                        sx={{ fontFamily: "'Poppins', sans-serif", fontSize: "0.65rem", background: "#eff6ff", color: "#2563eb", height: 18 }} />
                    )}
                  </Box>
                </Box>
              </Box>

              {/* Acciones */}
              <Box sx={{ display: "flex", gap: 0.5, flexShrink: 0 }}>
                <Tooltip title="Editar" placement="top">
                  <IconButton size="small" onClick={() => handleEdit(data)}
                    sx={{ color: "#f43f5e", "&:hover": { background: "#fff0f6" } }}>
                    <Edit fontSize="small" />
                  </IconButton>
                </Tooltip>
                <Tooltip title="Eliminar" placement="top">
                  <IconButton size="small" onClick={() => deleteFnc(data, index)}
                    sx={{ color: "#ef4444", "&:hover": { background: "#fff1f2" } }}>
                    <Delete fontSize="small" />
                  </IconButton>
                </Tooltip>
              </Box>
            </Box>
          ))}
        </Box>
      )}
    </>
  );
};

export default InsumosPrenda;
